"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_FEEDBACK_COOKIE_EXPIRATION = exports.USER_FEEDBACK_PROMPT_TIMEOUT = void 0;
/** Default amount of time to wait before showing modal  */
exports.USER_FEEDBACK_PROMPT_TIMEOUT = 30000;
/** Days to persist user feedback cookies */
exports.USER_FEEDBACK_COOKIE_EXPIRATION = 90;
//# sourceMappingURL=constants.js.map